var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedOne0)",
    d: "M15.917 5.143a3.086 3.086 0 0 0-3.06 2.949v3.287c-.3 0-.514.043-.857.043s-.557 0-.857.042V8.092c0-1.625-1.445-2.992-3.103-2.949c-1.577 0-2.855 1.367-2.897 2.949v7.86a2.957 2.957 0 0 0 3.025 2.905c1.616-.043 2.975-1.328 2.975-2.905V12.66c.3 0 .514-.043.857-.043s.557 0 .857-.043v3.335a3.064 3.064 0 0 0 3.103 2.948a2.97 2.97 0 0 0 2.897-2.948V8.092a2.95 2.95 0 0 0-2.94-2.949M8.125 6.43c.978 0 1.732.681 1.732 1.663v3.458a10.4 10.4 0 0 0-2.499.729a4.3 4.3 0 0 0-.93.6V8.087c0-.942.716-1.662 1.697-1.662zm1.732 9.523c0 .985-.754 1.62-1.732 1.62c-.981 0-1.697-.639-1.697-1.62v-.772c0-.681.502-1.363 1.44-1.748c.643-.3 1.265-.472 1.989-.6zm6.06 1.62c-.977 0-1.774-.639-1.774-1.62v-3.459a10.7 10.7 0 0 0 2.541-.729a4 4 0 0 0 .887-.6v4.788c0 .985-.716 1.62-1.654 1.62m.257-6.917c-.643.3-1.307.47-2.031.6V8.092c0-.986.797-1.663 1.774-1.663a1.58 1.58 0 0 1 1.654 1.663v.771c.043.724-.458 1.363-1.397 1.792"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedOne0",
    x1: 16.79,
    x2: 7.909,
    y1: 7.038,
    y2: 17.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E8A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1E2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.0c5e48d889cea0634015a703001da8a0.svg";
export { ForwardRef as ReactComponent };